import { render, staticRenderFns } from "./InsuranceDetail.vue?vue&type=template&id=b37b6b9c&"
import script from "./InsuranceDetail.vue?vue&type=script&lang=js&"
export * from "./InsuranceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports